export default value => (value && value.length)
